import { TableModule, UtilitiesModule } from '@coreui/angular';

import { CommonModule } from '@angular/common';
import { MonthlyExpensesPerItemRoutingModule } from './monthly-expenses-per-item-routing.module';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TableModule,
    UtilitiesModule,
    MonthlyExpensesPerItemRoutingModule,
  ]
})
export class MonthlyExpensesPerItemModule { }
